module.exports = __webpack_public_path__ + "img/15.308ea09b.jpg";